module.exports = __webpack_public_path__ + "static/media/108.d3956599.webp";